module.exports = __webpack_public_path__ + "public/img/HandShake.e83ef338.svg";